import { tns } from "tiny-slider/src/tiny-slider";

// featured items slider
export function testimonialSlider(el) {
    const element = document.querySelector(el);
    // don't start function if the element is not on the page
    if (!element) return;
    tns({
        container: el,
        items: 1,
        mouseDrag: true,
        autoplay: false,
        autoHeight: true,
        autoplayTimeout: 7500,
        controls: false,
        nav: true,
    });
}